$(document).on('click', 'a[data-action="quick-add-to-cart"]', function () {
   var qty = 1;
   var id = $(this).attr('data-variant-id');

    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: qty,
            id: id,
        },
        dataType: 'json',
        success: function(line_item) { 
            document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                    quantity: qty
                }
            }));
			if (window.location.href.indexOf("wishlist") > -1) {
				console.log('trigger remove of item from wishlist.');
		    }
        },
        error: function() {
            alert('sold out, sorry!');
        }
     };
     $.ajax(params);
});